<template>
  <div class="user-management-page">
    <div class="text-h4 q-mb-md text-left tab-heading-color">
      Accountbeheer
    </div>
    <q-card>
      <q-tabs
        v-model="userManagementTab"
        dense
        class="text-grey"
        align="justify"
        narrow-indicator
      >
        <q-tab name="customersBasicDetails" label="Accountgegevens"> </q-tab>
        <q-tab name="users" label="Gebruikers"> </q-tab>
      </q-tabs>

      <q-separator />
      <q-tab-panels v-model="userManagementTab" animated swipeable>
        <q-tab-panel name="customersBasicDetails">
          <q-input
            outlined
            label="Naam"
            type="text"
            lazy-rules
            dense
            class="q-ma-sm"
            style="width: 40vw; margin-top: 20px; margin-bottom: 20px"
            :disable="!enableEditMode"
            v-model="customerName"
          ></q-input>
          <q-input
            outlined
            label="Emailextensie"
            type="text"
            lazy-rules
            dense
            class="q-ma-sm"
            style="width: 40vw; margin-top: 20px; margin-bottom: 20px"
            disable
            v-model="customer.emailSuffix"
          >
          </q-input
          ><q-input
            outlined
            label="Aantal licenties"
            type="text"
            lazy-rules
            dense
            class="q-ma-sm"
            style="width: 40vw; margin-top: 20px; margin-bottom: 20px"
            disable
            v-model="customer.numberOfLicences"
          >
          </q-input>

          <div class="on-right" style="width: 40vw">
            <div v-if="enableEditMode == false" class="q-ma-sm float-right">
              <q-btn
                color="primary"
                icon="edit"
                class="save-btn"
                @click="enableEditMode = true"
              >
                <q-tooltip>Bewerk</q-tooltip>
              </q-btn>
            </div>
            <div v-if="enableEditMode == true" class="q-ma-sm float-right">
              <q-btn
                color="primary"
                icon="save"
                class="save-btn"
                @click="saveChanges"
              >
                <q-tooltip>Opslaan</q-tooltip>
              </q-btn>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel name="users">
          <div id="q-app" style="min-height: 100vh;">
            <div class="q-pa-md">
              <q-table
                class="sticky-header"
                table-header-style="background-color: #0a1f8f"
                table-header-class="text-white"
                :rows="customerUsers"
                :columns="usersTableColumns"
                row-key="id"
                :filter="filterUsers"
                :filter-method="usersFilter"
                :rows-per-page-label="'Resultaten per pagina'"
                :pagination="pagination"
              >
                <template v-slot:top>
                  <q-input
                    borderless
                    dense
                    debounce="300"
                    color="primary"
                    placeholder="Zoek"
                    v-model="filterUsers"
                  >
                    <template v-slot:append>
                      <q-icon name="search" />
                    </template>
                  </q-input>
                  <q-space></q-space>
                  <q-btn
                    style="background: #25408f; color: white;"
                    :disable="loading"
                    label="Voeg nieuwe gebruiker toe"
                    @click="enableAddUser"
                    dense
                  >
                    <i class="las la-2x la-plus-circle la-fw"></i>
                  </q-btn>
                </template>

                <template v-slot:body="props">
                  <q-tr :props="props">
                    <q-td key="firstName" :props="props">{{
                      props.row.firstName
                    }}</q-td>
                    <q-td key="lastName" :props="props">{{
                      props.row.lastName
                    }}</q-td>
                    <q-td key="email" :props="props">{{
                      props.row.email
                    }}</q-td>
                    <q-td key="isActive" :props="props">
                      <i
                        v-if="props.row.isActive"
                        class="las la-2x la-check"
                        style="color: green;"
                      ></i>
                      <i
                        v-if="!props.row.isActive"
                        class="las la-2x la-times"
                        style="color: red;"
                      ></i>
                    </q-td>
                    <q-td key="actions" :props="props" class="q-gutter-xs">
                      <q-btn
                        color="positive"
                        size="sm"
                        no-caps
                        @click="sendPasswordSetupMail(props.row.userId)"
                      >
                        <i class="las la-2x la-mail-bulk la-fw"></i>
                        <q-tooltip>
                          Herstel wachtwoord
                        </q-tooltip>
                      </q-btn>
                      <q-btn
                        v-if="props.row.isActive"
                        color="red"
                        @click="
                          (confirmDeactivation = true),
                            (selectedUserId = props.row.userId)
                        "
                        size="sm"
                        no-caps
                      >
                        <i class="las la-2x la-ban la-fw"></i>
                        <q-tooltip>
                          De-activeren
                        </q-tooltip>
                      </q-btn>
                      <q-btn
                        v-if="!props.row.isActive"
                        color="info"
                        @click="
                          (confirmReactivation = true),
                            (selectedUserId = props.row.userId)
                        "
                        size="sm"
                        no-caps
                      >
                        <i class="las la-2x la-sync la-fw"></i>
                        <q-tooltip>
                          Reactivate
                        </q-tooltip>
                      </q-btn>
                      <q-btn
                        color="indigo"
                        size="sm"
                        no-caps
                        @click="enableEditUser(props.row)"
                      >
                        <i class="las la-2x la-edit la-fw"></i>
                        <q-tooltip>
                          Bewerk
                        </q-tooltip>
                      </q-btn>
                    </q-td>
                  </q-tr>
                </template>
              </q-table>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
  <q-dialog v-model="confirmDeactivation" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <i class="las la-2x la-ban la-fw"></i>
        <span class="q-ml-sm">Wil je deze gebruiker de-activeren?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          style="color: #0a108f; border: 1px solid gray; border-radius: 5px;"
          no-caps
          flat
          label="Annuleren"
          outline
          v-close-popup
          dense
        />
        <q-btn
          style="background: #0a108f; color: white;"
          no-caps
          flat
          label="Deactiveren"
          v-close-popup
          @click="deactivateUser(selectedUserId)"
          dense
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="confirmReactivation" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <i class="las la-2x la-sync la-fw"></i>
        <span class="q-ml-sm">Wil je deze gebruiker activeren?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          style="color: #0a108f; border: 1px solid gray; border-radius: 5px;"
          no-caps
          flat
          label="Annuleren"
          outline
          v-close-popup
          dense
        />
        <q-btn
          style="background: #0a108f; color: white;"
          no-caps
          flat
          label="Reactiveren"
          v-close-popup
          @click="reactivateUser(selectedUserId)"
          dense
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="showEmailSentDialog" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <i class="las la-2x la-check la-fw"></i>
        <span class="q-ml-sm">Email verstuurd!</span>
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          outline
          label="Ok"
          color="primary"
          @click="disableEmailSentDialog()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="userCreatedDialog" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <i class="las la-2x la-check la-fw"></i>
        <span class="q-ml-sm"
          >Er is een uitnodiging voor activatie naar de gebruiker gestuurd</span
        >
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          outline
          label="Ok"
          color="primary"
          @click="disableUserCreatedDialog()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <AddNewUser />
  <EditUser v-if="showEditUserComponent" />
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import store from '../../store/index.js';
import UserService from '../../services/userprofile.service';
import AddNewUser from './AddNewUser.vue';
import EditUser from './EditUser.vue';

export default {
  components: {
    AddNewUser,
    EditUser,
  },
  setup() {
    const usersTableColumns = [
      {
        name: 'firstName',
        align: 'left',
        label: 'Voornaam',
        field: 'firstName',
        sortable: true,
      },
      {
        name: 'lastName',
        align: 'left',
        label: 'Achternaam',
        field: 'lastName',
        sortable: true,
      },
      {
        name: 'email',
        align: 'left',
        label: 'Email',
        field: 'email',
        sortable: true,
      },
      {
        name: 'isActive',
        align: 'center',
        label: 'Is actief',
        field: 'isActive',
      },
      {
        name: 'actions',
        align: 'center',
        label: '',
      },
    ];

    const filterUsers = ref('');
    const enableEditMode = ref(false);
    const userManagementTab = ref('customersBasicDetails');
    const confirmDeactivation = ref(false);
    const confirmReactivation = ref(false);
    const selectedUserId = ref(null);

    onMounted(async () => {
      await UserService.getCustomerByUser();
    });

    const customer = computed({
      get: () => store.state.user.customer,
    });

    const customerId = computed({
      get: () => store.state.user.customer.id,
    });

    const customerName = computed({
      get: () => store.state.user.customer.name,
      set: (value) => store.commit('user/updateCustomerName', value),
    });

    const customerUsers = computed({
      get: () => store.state.user.customer.persons,
    });

    const updatedCustomer = {
      id: customerId,
      name: customerName,
    };

    const saveChanges = async () => {
      enableEditMode.value = false;
      await UserService.updateCustomerName(updatedCustomer);
    };

    const enableAddUser = () => {
      store.commit('user/enableAddUser');
    };

    const enableEditUser = (row) => {
      store.commit('user/enableEditUser', row);
    };

    const showEditUserComponent = computed({
      get: () => store.state.user.showEditUserDialog,
    });

    const showEmailSentDialog = computed({
      get: () => store.state.user.showEmailSentDialog,
    });

    const disableEmailSentDialog = () => {
      store.commit('user/disableEmailSentDialog');
    };

    const userCreatedDialog = computed({
      get: () => store.state.user.showUserCreatedDialog,
    });

    const disableUserCreatedDialog = () => {
      store.commit('user/disableUserCreatedDialog');
    };

    const sendPasswordSetupMail = async (userId) => {
      await UserService.sendPasswordSetupMail(userId);
    };

    const deactivateUser = async (selectedUserId) => {
      await UserService.deactivateUser(selectedUserId);
      confirmDeactivation.value = false;
    };

    const reactivateUser = async (selectedUserId) => {
      await UserService.reactivateUser(selectedUserId);
      confirmReactivation.value = false;
    };
    const pagination = {
      page: 1,
      rowsPerPage: 20,
    };

    return {
      pagination,
      selectedUserId,
      deactivateUser,
      reactivateUser,
      userCreatedDialog,
      disableUserCreatedDialog,
      userManagementTab,
      customer,
      enableEditMode,
      saveChanges,
      customerName,
      usersTableColumns,
      updatedCustomer,
      filterUsers,
      customerUsers,
      customerId,
      enableAddUser,
      enableEditUser,
      sendPasswordSetupMail,
      showEmailSentDialog,
      disableEmailSentDialog,
      confirmDeactivation,
      confirmReactivation,
      showEditUserComponent,
      usersFilter(rows, terms) {
        // rows - contains the entire data
        // terms - contains whatever you have as filter
        const lowerFilter = terms ? terms.toLowerCase() : '';
        if (lowerFilter != '') {
          return rows.filter(
            (row) => row.firstName.toLowerCase().indexOf(lowerFilter) > -1
          );
        } else {
          return rows;
        }
      },
    };
  },
};
</script>
